import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable, Injector, isDevMode} from "@angular/core";
import {Observable, of, throwError} from "rxjs";
import {environment} from "../environments/environment";
import {catchError, switchMap} from 'rxjs/operators';
import UserService from '../api/user/user.service';

@Injectable()
export default class RequestInterceptor implements HttpInterceptor {
    private userService: UserService;

    private authRequiredUrls = ['/'];

    constructor(inj: Injector) {
        this.userService = inj.get(UserService);
    }


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers = {
            'Content-Type': 'application/json'
        };

        /* If the header wo-intercept is set, complete request without further changes. */
        if(req.headers.has('wo-intercept')) {
          let headers = req.headers;
          headers = headers.delete('wo-intercept');
          req = req.clone({
            headers: headers
          });
          return next.handle(req);
        }

        /* If the route is not a login route, check if authentication (and thus the bearer token) is required. If so, add
        * it to the request headers. */
        if(req.urlWithParams.indexOf('/login') < 0) {
            let requiresAuthHeader = false;
            for(let url of this.authRequiredUrls) {
              if(req.urlWithParams
                .replace(environment.apiUrl, '')
                .replace(environment.ssoUrl, '').indexOf(url) === 0) {
                requiresAuthHeader = true; break;
              }
            }
            if(this.userService.ssoToken != null && requiresAuthHeader) {
              headers['X-Sso-Token'] =  this.userService.ssoToken;
            } else if(this.userService.token != null && requiresAuthHeader) {
                headers['Authorization'] =  'Bearer ' + this.userService.token;
            }
        }

        let newReq = req.clone({
            headers: new HttpHeaders(headers)
        });

        /* When dev mode is active and xdebug should be used, add the parameter. */
        if(environment.xdebug) {
            let newUrl = {urlWithParams: newReq.urlWithParams + '?XDEBUG_SESSION_START=phpstorm'};
            if (newReq.urlWithParams.indexOf('?') > 0) {
                newUrl = {urlWithParams: newReq.urlWithParams + '&XDEBUG_SESSION_START=phpstorm'};
            }
            newReq = Object.assign(newReq, newUrl);
        }

        return next.handle(newReq).pipe(catchError(err => {
            if(err.status == 401 && (this.userService.ssoToken != null)) {
              console.log('Attempt a refresh', this.userService);
                // try to get a new token with refresh token
                if(this.userService.refreshToken != null) {
                  return this.userService.refreshJwt().pipe(switchMap(token => {
                    this.userService.ssoToken = token;
                    // redo without auth
                    const headers = {
                      'Content-Type': 'application/json',
                      'X-Sso-Token': this.userService.ssoToken
                    };
                    newReq = newReq.clone({
                      headers: new HttpHeaders(headers)
                    });
                    return next.handle(newReq);
                  }));
                } else {
                  // remove login token
                  this.userService.logout();
                  return throwError(err);
                }
            } else if(err.status == 412 && newReq.method.toLowerCase() == 'delete') {
                // show text input for deletion reason and after that retry request
                const reason = prompt('Grund für Löschung angeben');
                if(reason) {
                    headers['X-Deletion-Reason'] = encodeURIComponent(reason);
                    let newReq = req.clone({
                        headers: new HttpHeaders(headers)
                    });
                    return next.handle(newReq);
                } else {
                    return throwError(err);
                }
            } else if(err.status == 401) {
                // redo without auth
                const headers = {
                  'Content-Type': 'application/json'
                };
                newReq = newReq.clone({
                  headers: new HttpHeaders(headers)
                });

                return next.handle(newReq);
            }
            return throwError(err);
        }));
    }
}
